module.exports = __webpack_public_path__ + "img/bluelabel.b3fa852a.jpg";